/* eslint-disable */
var icon = require('vue-svgicon');
icon.register({
    'dash-circle-fill': {
        width: 16,
        height: 16,
        viewBox: '0 0 16 16',
        data: '<path pid="0" d="M16 8A8 8 0 110 8a8 8 0 0116 0M4.5 7.5a.5.5 0 000 1h7a.5.5 0 000-1z"/>',
    },
});
